import { useEffect, useRef } from 'react';

import { GlobalDialogType } from 'stores/global-dialogs/global-dialogs.store.types';

import { isEmpty, isEqual, xorWith } from 'lodash';
import { EventBus } from 'services/event-bus/EventBus';
import { useGlobalDialogsStore } from 'stores/global-dialogs/global-dialogs.store';
import { useGlobalDialogData } from 'stores/global-dialogs/hooks/useGlobalDialogData';

export const useCommitTransactionWhenClosingOutreachDialog = () => {
  const esPersonId = useGlobalDialogData(
    { dialogType: GlobalDialogType.CandidateOutreach },
    (s) => s.candidate.es_person_id,
  );

  const esPersonIdRef = useRef(esPersonId);

  useEffect(() => {
    esPersonIdRef.current = esPersonId;
  }, [esPersonId]);

  useEffect(() => {
    return useGlobalDialogsStore.subscribe((state, prevState) => {
      if (isEmpty(xorWith(prevState.activeDialogs, state.activeDialogs, isEqual))) {
        return;
      }

      const wasActive = prevState.activeDialogs.some((dialog) => dialog.type === GlobalDialogType.CandidateOutreach);
      const isActive = state.activeDialogs.some((dialog) => dialog.type === GlobalDialogType.CandidateOutreach);

      const esPersonId = esPersonIdRef.current;

      if (wasActive && !isActive && esPersonId) {
        if (EventBus.isTransactionActive(esPersonId)) {
          EventBus.commitTransaction(esPersonId);
        }
      }
    });
  }, []);
};
